import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=2e164649&"
import script from "./UserTransactions.vue?vue&type=script&lang=js&"
export * from "./UserTransactions.vue?vue&type=script&lang=js&"
import style0 from "./UserTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports